<template>
  <div>
    <stop-card :icon="icon" :title="title" :state="cardState" @click="onClick()" />
  </div>
</template>

<script setup lang="ts">
import { ActualStop, JobStopType } from '@ironsight/types'
import { useStore } from 'vuex-composition-helpers'
import StopCard from '@/components/tickets/StopsAndInventories/StopCard.vue'
import { computed } from 'vue'

const props = defineProps<{
  stop: ActualStop
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()

const onClick = () => {
  emit('click')
}

const store = useStore()

const cardState = computed(() => (props.stop.isSkipped ? 'errored' : 'completed'))

const getUserName = computed(() => {
  return store.getters['users/getBySid'](props.stop.createdBy)?.name || 'Unknown'
})

const icon = computed(() => {
  return props.stop.isSkipped ? 'mdi-cancel' : 'mdi-receipt-text-outline'
})

const title = computed(() => {
  if (props.stop.isSkipped) {
    return `${
      props.stop.stopType === JobStopType.PickUp ? 'Pickup' : 'Dropoff'
    } skipped by ${getUserName.value} ${props.stop.arrivedAt.format('MMM D, YYYY HH:mm')}`
  } else {
    return `Action confirmed by ${
      getUserName.value
    } ${props.stop.arrivedAt.format('MMM D, YYYY HH:mm')}`
  }
})
</script>
